import { Factory } from 'rosie';

Factory.define('CustomerNote');

Factory.define('CustomerNoteWithDefaults')
  .extend('CustomerNote')
  .attr('content', 'You should clone yourself while you\'re still alive.');
